import React from 'react'

function DestDetail() {
  return (
    <div className='DestDetail'></div>
  )
}

export default DestDetail